// --------------------------------------------------
// RAZ SYSTEM — API → INTERNAL COMPETITION MAP
// PHASE 3 — CANONICAL DOMESTIC IDS
// --------------------------------------------------

export const API_TO_CONCEPT_MAP: Record<
  number,
  string
> = {
  // ==================================================
  // 🌍 INTERNATIONAL
  // ==================================================

  51: "six-nations-men",
  55: "six-nations-women",

  85: "rugby-championship-men",

  69: "world-cup-men",
  70: "world-cup-women",

  93: "autumn-nations-men",

  84: "international-tests-men",

  97: "womens-internationals",

  90: "pacific-nations-cup",

  // ==================================================
  // 🏉 DOMESTIC — MEN
  // ==================================================

  76: "urc-men",

  16: "top14-men",

  13: "premiership-men",

  71: "super-men",

  17: "pro-d2-men",

  27: "japan-men",

  54: "investec-men",

  52: "epcr-men",

  // ==================================================
  // 🏉 WOMEN
  // ==================================================

  91: "super-women",

  136: "aupiki-women",

  // ==================================================
  // ⚡ SVNS
  // ==================================================

  86: "svns",
  87: "svns",

  110: "svns",
  119: "svns",
  121: "svns",
  115: "svns",
  113: "svns",
  120: "svns",
  112: "svns",
  130: "svns",
  114: "svns",

  123: "svns",
  126: "svns",
  133: "svns",
  122: "svns",
  135: "svns",
  127: "svns",
  125: "svns",
  129: "svns",
  131: "svns",
  124: "svns",
};